import {
  SET_APP_LANGUAGE, SET_USER_PROFILE, SET_FEATURE_LIST, SET_INVOICE_NUMBER, SET_MENU_LIST, SET_LOGIN_DETAILS
} from '../utils/constants'

export const setAppLanguage = (payload) => ({ type: SET_APP_LANGUAGE, payload })
export const setUserProfile = (payload) => ({ type: SET_USER_PROFILE, payload })
export const setFeatureList = (payload) => ({ type: SET_FEATURE_LIST, payload })
export const setInvoiceNumber = (payload) => ({ type: SET_INVOICE_NUMBER, payload })
export const setMenuList = (payload) => ({ type: SET_MENU_LIST, payload })
export const setLoginDetails = (payload) => ({ type: SET_LOGIN_DETAILS, payload })